export enum AttachmentsSortField {
  Name = 1,
  FileName = 2,
  LastChanged = 3,
}
